import { Reveal, Overline } from "./Reveal";
import { Dumbbell, Target, Apple, TrendingUp, ShieldCheck, Repeat } from "lucide-react";

const items = [
  { icon: Dumbbell, title: "Customized Programs", desc: "Every plan is built specifically around your body, goals, schedule, and equipment." },
  { icon: ShieldCheck, title: "Accountability", desc: "Consistent check-ins and support that keep you on track when motivation fades." },
  { icon: Apple, title: "Sustainable Nutrition", desc: "No crash diets. Realistic nutrition you can actually maintain for life." },
  { icon: TrendingUp, title: "Real Transformation", desc: "Proven methods that build muscle, burn fat, and reshape your physique." },
  { icon: Target, title: "Confidence", desc: "Watch your confidence grow as your body, strength, and discipline improve." },
  { icon: Repeat, title: "Long-Term Lifestyle", desc: "This isn't a quick fix — it's a permanent change in how you live." },
];

export const WhyChoose = () => {
  return (
    <section id="why" className="relative py-24 md:py-32 bg-[#141414]">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <Reveal className="max-w-2xl">
          <Overline>Why Choose Us</Overline>
          <h2 className="font-display font-semibold uppercase tracking-tight text-white text-3xl sm:text-4xl lg:text-5xl mt-4 leading-tight">
            More Than Workouts. A Complete System.
          </h2>
        </Reveal>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {items.map((item, i) => (
            <Reveal key={item.title} delay={i * 0.06}>
              <div
                data-testid={`why-card-${i}`}
                className="group h-full bg-[#0A0A0A] border border-[#262626] p-8 hover:-translate-y-1 hover:border-[#0055FF] transition-all duration-300"
              >
                <div className="w-12 h-12 flex items-center justify-center bg-[#0055FF]/10 border border-[#0055FF]/30 mb-6 group-hover:bg-[#0055FF] transition-colors">
                  <item.icon size={22} className="text-[#0055FF] group-hover:text-white transition-colors" />
                </div>
                <h3 className="font-display font-semibold text-xl text-white">{item.title}</h3>
                <p className="mt-3 text-sm text-[#A3A3A3] leading-relaxed">{item.desc}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
